module.exports = __webpack_public_path__ + "img/BSFZ_Siegel_2025.b44d23b1.png";